/**
 * Kural property'lerinin senkron kaynaklardan okunmasi.
 * `js` kaynagi burada ele alinmaz (bkz. jsRunner.js).
 *
 * Kisisel veri korunur: `field` kaynagi yalnizca pii isaretiyle kullanilabilir
 * ve deger resolveProps icinde hash'lenerek gonderilir.
 */
import { LIMITS } from "./schema";
import { toNumber, readPath } from "./jsRunner";

/** Element ya da en yakin ust element uzerinden attribute okur. */
function readAttr(element, name) {
    if (!element) return null;
    try {
        if (element.hasAttribute && element.hasAttribute(name)) return element.getAttribute(name);
        const holder = element.closest ? element.closest("[" + name + "]") : null;
        return holder ? holder.getAttribute(name) : null;
    } catch (e) {
        return null;
    }
}

/** Seciciyi once tetiklenen elementin icinde, bulunamazsa sayfada arar. */
function queryScoped(selector, element) {
    try {
        if (element && element.querySelector) {
            const scoped = element.querySelector(selector);
            if (scoped) return scoped;
        }
        return document.querySelector(selector);
    } catch (e) {
        return null;
    }
}

function readText(selector, element) {
    const node = queryScoped(selector, element);
    if (!node) return null;
    const text = String(node.innerText || node.textContent || "").replace(/\s+/g, " ").trim();
    return text || null;
}

function readField(selector, element) {
    // Form gonderiminde alan formun icinde aranir
    const form = element && element.closest ? element.closest("form") : null;
    const node = queryScoped(selector, form || element);
    if (!node) return null;
    const value = node.value;
    return value === undefined || value === null || value === "" ? null : value;
}

function readQueryParam(name) {
    try {
        return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
        return null;
    }
}

function readMeta(name) {
    try {
        const node = document.querySelector('meta[name="' + name + '"], meta[property="' + name + '"]');
        return node ? node.getAttribute("content") : null;
    } catch (e) {
        return null;
    }
}

/**
 * Degeri hedef tipe cevirir.
 * Nesne/dizi donen js sonuclari JSON'a cevrilir (rapor tarafinda string olarak tutulur).
 * @returns {*} donusturulemeyen deger icin null
 */
export function coerce(value, type) {
    if (value === null || value === undefined || value === "") return null;

    if (type === "number") {
        const parsed = toNumber(value);
        return parsed === null ? null : parsed;
    }
    if (type === "boolean") {
        if (typeof value === "boolean") return value;
        const text = String(value).trim().toLowerCase();
        if (text === "true" || text === "1" || text === "yes") return true;
        if (text === "false" || text === "0" || text === "no") return false;
        return null;
    }

    if (typeof value === "object") {
        try {
            return JSON.stringify(value).slice(0, LIMITS.maxStringifiedLength);
        } catch (e) {
            return null;
        }
    }
    return String(value).slice(0, LIMITS.maxStringifiedLength);
}

/**
 * Senkron kaynaklardan ham degeri okur.
 * @param {Object} mapping { from, value, type }
 * @param {Object} context { el }
 * @returns {*} bulunamazsa null
 */
export function extractValue(mapping, context) {
    const element = context && context.el;
    const from = mapping.from;
    const source = mapping.value;

    if (from === "const") return source;
    if (from === "attr") return readAttr(element, source);
    if (from === "text") return readText(source, element);
    if (from === "field") return readField(source, element);
    if (from === "query") return readQueryParam(source);
    if (from === "global") return readPath(source);
    if (from === "meta") return readMeta(source);
    return null;
}



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/rules/extract.js
// module id = null
// module chunks = 